import { type IInternalContactAgreement } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IInternalContactAgreementState } from './types';

export const GET_FROM_AGREEMENT = 'getFromAgreement';

const getInternalContactAgreement = (_state: IInternalContactAgreementState, ids = [] as number[]): IInternalContactAgreement[] => {
    return ids
        .map((internalContactAgreementId: number) => {
            return _state.dataObjectList.get(internalContactAgreementId);
        })
        .filter((internalContactAgreement) => {
            return internalContactAgreement;
        });
};

export const getters: GetterTree<IInternalContactAgreementState, unknown> = {
    [GET_FROM_AGREEMENT]: (_state: IInternalContactAgreementState) => {
        return (agreementId: number): IInternalContactAgreement[] | undefined => {
            return getInternalContactAgreement(_state, _state.byAgreement.get(agreementId) ?? []);
        };
    }
};
